// Pure helpers for chapter playback navigation. Kept free of React and
// browser globals so they can be unit-tested directly.

// Reading order across the whole project: files in position order, chapters
// in order within each file. `order` alone is not unique in multi-file
// projects — each file restarts at 1.
export function sortChaptersByOrder(chapters) {
  if (!Array.isArray(chapters)) return [];
  return [...chapters].sort(
    (a, b) => (a.file_position || 0) - (b.file_position || 0) || a.order - b.order,
  );
}

// mm:ss — used for chapter durations and playback positions.
export function formatDuration(seconds) {
  if (seconds == null || seconds < 0) return '00:00';
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}

// mm:ss under an hour, HH:mm:ss from an hour up.
export function formatHms(seconds) {
  const s = Math.max(0, Math.floor(seconds || 0));
  if (s < 3600) return formatDuration(s);
  return `${String(Math.floor(s / 3600)).padStart(2, '0')}:${formatDuration(s % 3600)}`;
}

export function getAdjacentChapter(chapters, currentChapterId, direction) {
  const sorted = sortChaptersByOrder(chapters);
  const idx = sorted.findIndex((ch) => ch.chapter_id === currentChapterId);
  if (idx === -1) return null;
  const newIdx = direction === 'next' ? idx + 1 : idx - 1;
  if (newIdx < 0 || newIdx >= sorted.length) return null;
  return sorted[newIdx];
}

export function getNextChapter(chapters, currentChapterId) {
  return getAdjacentChapter(chapters, currentChapterId, 'next');
}

export function getPreviousChapter(chapters, currentChapterId) {
  return getAdjacentChapter(chapters, currentChapterId, 'prev');
}
